import React, { Component } from "react";
import classNames from "classnames";
// import _ from 'lodash';
import {RichText as PrismicRichText} from 'prismic-reactjs';
// import {Link} from 'react-router-dom';
import {PrismicConfig} from "../../config";
import "./PullQuote.css";

export default class Resource extends Component {

	componentDidMount() {
		
	}

	sectionClasses() {
		let classes = {
			"pull-quote": true,
			[`-${this.props.content.color}`]: true
		}
		return classNames(classes);
	}
	
	render() {
		const content = this.props.content;

		if(!content || !content.body) return;

		return (
			<div className={this.sectionClasses()}>
				{PrismicRichText.render(content.body, PrismicConfig.linkResolver)}
			</div>
		);
	}
}	


// WEBPACK FOOTER //
// ./src/components/PullQuote/PullQuote.js